import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export function MobileProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-orange-300 to-orange-200">
        <div
          className="h-8 w-8 animate-spin rounded-full border-4 border-orange-600 border-t-transparent"
          aria-hidden
        />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/mobile/login" replace />;
  }

  const isEmailProvider = (user.app_metadata?.provider ?? "email") === "email";
  if (user.email && isEmailProvider && !user.email_confirmed_at) {
    return <Navigate to="/auth/verification-email" replace />;
  }

  return <>{children}</>;
}
